import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import {
  group_detail_url,
  list_of_divisions_url,
  group_playoffs_url,
} from "../utils/constants";
import styled from "styled-components";
import { season_id } from "../utils/constants";
import { ListViewOld, PlayoffsView } from "../components";
import { Link } from "react-router-dom";

// URL: /season/:seasonId/group/:groupId
const Group = () => {
  const { seasonId, groupId } = useParams();

  const [groupIdentifier, setGroupIdentifier] = useState(groupId);
  const [groupInProgress, setGroupInProgress] = useState(false);
  const [groupCompleted, setGroupCompleted] = useState(false);
  const [groupError, setGroupError] = useState(false);
  const [groupInfo, setGroupInfo] = useState();

  const [isRegularLeague, setIsRegularLeague] = useState(false);

  const [divisionsInProgress, setDivisionsInProgress] = useState(false);
  const [divisionsCompleted, setDivisionsCompleted] = useState(false);
  const [divisionsError, setDivisionsError] = useState(false);
  const [divisionsInfo, setDivisionsInfo] = useState();

  const [playoffsInProgress, setPlayoffsInProgress] = useState(false);
  const [playoffsCompleted, setPlayoffsCompleted] = useState(false);
  const [playoffsError, setPlayoffsError] = useState(false);
  const [playoffsInfo, setPlayoffsInfo] = useState();

  const season =
    parseInt(seasonId) !== season_id ? "La temporada no existe" : "";

  const loadDivisionDetails = async () => {
    setDivisionsInProgress(true);
    const url = `${list_of_divisions_url}`;

    try {
      setDivisionsInProgress(true);
      const response = await axios.get(url);
      if (response.status === 200) {
        var division = response.data.filter((div) =>
          div.groups.some((group) => group.groupId === groupIdentifier)
        );

        setDivisionsInfo(division[0]);

        setDivisionsInProgress(false);
        setDivisionsCompleted(true);
        return true;
      } else {
        console.log(`(${response.status}) response: ${response.data}`);
        setDivisionsInProgress(false);
        setDivisionsError(true);
        return false;
      }
    } catch (error) {
      setDivisionsInProgress(false);
      setDivisionsError(true);
      return false;
    }
  };

  const loadGroupDetails = async () => {
    setGroupInProgress(true);
    const url = `${group_detail_url.replace(":groupId", groupIdentifier)}`;

    try {
      setGroupInProgress(true);
      const response = await axios.get(url);
      if (response.status === 200) {
        setGroupInfo(response.data);

        setGroupInProgress(false);
        setGroupCompleted(true);
        return true;
      } else {
        console.log(`(${response.status}) response: ${response.data}`);
        setGroupInProgress(false);
        setGroupError(true);
        return false;
      }
    } catch (error) {
      setGroupInProgress(false);
      setGroupError(true);
      return false;
    }
  };

  const loadPlayoffMatches = async () => {
    setPlayoffsInProgress(true);
    const url = `${group_playoffs_url.replace(":groupId", groupIdentifier)}`;

    try {
      setPlayoffsInProgress(true);
      const response = await axios.get(url);
      if (response.status === 200) {
        setPlayoffsInfo(response.data);

        setPlayoffsInProgress(false);
        setPlayoffsCompleted(true);
        return true;
      } else {
        console.log(`(${response.status}) response: ${response.data}`);
        setPlayoffsInProgress(false);
        setPlayoffsError(true);
        return false;
      }
    } catch (error) {
      setPlayoffsInProgress(false);
      setPlayoffsError(true);
      return false;
    }
  };

  useEffect(() => {
    if (!season) {
      loadGroupDetails();
      loadDivisionDetails();
      loadPlayoffMatches();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupIdentifier]);

  if (
    groupInProgress ||
    groupError ||
    !groupCompleted ||
    divisionsInProgress ||
    divisionsError ||
    !divisionsCompleted ||
    playoffsInProgress ||
    playoffsError ||
    !playoffsCompleted
  ) {
    return (
      <Wrapper>
        <div className="loading">
          <div className="lds-dual-ring"></div>
        </div>
      </Wrapper>
    );
  }

  if (season || groupError || !groupInfo) {
    return (
      <main>
        <Wrapper className="page section section-center">
          <div className="error">La temporada o el grupo no existen.</div>
        </Wrapper>
      </main>
    );
  }

  return (
    <Wrapper>
      <article>
        <p className="breadcrumb">
          <span>Temporada {seasonId}</span>
          <span className="separator">&gt;</span>
          <span>{divisionsInfo.name}</span>
          <span className="separator">&gt;</span>
          <span>{groupInfo.name}</span>
        </p>
        <GroupInfo>
          <div className="groups-list">
            {isRegularLeague
              ? divisionsInfo.groups.map((group) => {
                  return (
                    <div
                      key={group.groupId}
                      className={`group-sel ${
                        group.groupId === groupIdentifier ? "selected" : ""
                      }`}
                    >
                      <Link
                        to={`/season/${season_id}/group/${group.groupId}`}
                        onClick={() => setGroupIdentifier(group.groupId)}
                      >
                        {group.name}
                      </Link>
                    </div>
                  );
                })
              : ""}
          </div>
          <div className="phase-selector">
            <div
              className={`group-sel ${isRegularLeague ? "selected" : ""}`}
              onClick={() => setIsRegularLeague(true)}
            >
              Liga
            </div>{" "}
            <div
              className={`group-sel ${!isRegularLeague ? "selected" : ""}`}
              onClick={() => setIsRegularLeague(false)}
            >
              Playoffs
            </div>
          </div>
        </GroupInfo>

        {isRegularLeague ? <ListViewOld group={groupInfo} /> : ""}
        {!isRegularLeague ? <PlayoffsView playoffs={playoffsInfo} /> : ""}
      </article>

      <img
        className="background"
        src="https://alexocampos.github.io/liga-espanhola-aoe2-static/assets/bannerE.png"
        alt="background 1"
      />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 2rem;

  article {
    display: flex;
  }

  .background {
    width: 100%;
    position: absolute;
    z-index: -10;
    top: var(--header-height);
    right: 0;
    opacity: 0.5;
  }

  article {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  .breadcrumb {
    display: flex;
    justify-content: flex-start;
    width: 100%;

    .separator {
      margin-left: 0.5rem;
      margin-right: 0.5rem;
    }
  }

  .error {
    margin: 3rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width: 600px) {
    .no-mobile {
      display: none;
    }
  }
`;

const GroupInfo = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 2rem;

  .groups-list {
    width: 70%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
  }

  .group-sel {
    border: 1px solid var(--clr-grey-1);
    padding: 0.7rem;
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    display: flex;
    align-items: center;
  }
  .selected {
    background-color: var(--clr-grey-1);
    color: var(--clr-black);
    a {
      color: var(--clr-black);
    }
  }

  .phase-selector {
    width: 30%;
    display: flex;
    justify-content: flex-end;
  }

  @media (max-width: 550px) {
    .group-sel {
      padding: 0.4rem;
    }
  }
`;

export default Group;
